import { Text } from '@/components/atoms';
import { PhotoExifMetadata } from '@/types/exif';
import { formatExifCompact, formatCameraAndLens } from '@/utils/exif';

export interface ExifFooterProps {
  exif: PhotoExifMetadata | null;
  className?: string;
}

export function ExifFooter({ exif, className = '' }: ExifFooterProps) {
  const cameraInfo = formatCameraAndLens(exif);
  const settings = formatExifCompact(exif);

  if (!cameraInfo && !settings) {
    return null;
  }

  return (
    <div className={`pt-2 border-t border-border/30 ${className}`}>
      {cameraInfo && (
        <Text variant="caption" className="text-muted block">
          {cameraInfo}
        </Text>
      )}
      {settings && (
        <Text variant="caption" className="text-muted block">
          {settings}
        </Text>
      )}
    </div>
  );
}
